import AllCountries from 'react-intl-tel-input/dist/components/AllCountries'

import { type Country, CountryCodes } from './types'

const allowedCountries = {
  [CountryCodes.AE]: 'United Arab Emirates',
  [CountryCodes.AI]: 'Anguilla',
  [CountryCodes.AG]: 'Antigua and Barbuda',
  [CountryCodes.AR]: 'Argentina',
  [CountryCodes.AU]: 'Australia',
  [CountryCodes.AT]: 'Austria',
  [CountryCodes.BS]: 'Bahamas',
  [CountryCodes.BB]: 'Barbados',
  [CountryCodes.BE]: 'Belgium',
  [CountryCodes.BZ]: 'Belize',
  [CountryCodes.BM]: 'Bermuda',
  [CountryCodes.BO]: 'Bolivia',
  [CountryCodes.BR]: 'Brazil',
  [CountryCodes.BG]: 'Bulgaria',
  [CountryCodes.KY]: 'Cayman Islands',
  [CountryCodes.CL]: 'Chile',
  [CountryCodes.CO]: 'Colombia',
  [CountryCodes.CR]: 'Costa Rica',
  [CountryCodes.HR]: 'Croatia',
  [CountryCodes.CY]: 'Cyprus',
  [CountryCodes.CZ]: 'Czechia',
  [CountryCodes.DK]: 'Denmark',
  [CountryCodes.DM]: 'Dominica',
  [CountryCodes.DO]: 'Dominican Republic',
  [CountryCodes.EC]: 'Ecuador',
  [CountryCodes.SV]: 'El Salvador',
  [CountryCodes.EE]: 'Estonia',
  [CountryCodes.FO]: 'Faroe Islands',
  [CountryCodes.FI]: 'Finland',
  [CountryCodes.FR]: 'France',
  [CountryCodes.GE]: 'Georgia',
  [CountryCodes.DE]: 'Germany',
  [CountryCodes.GR]: 'Greece',
  [CountryCodes.GL]: 'Greenland',
  [CountryCodes.GD]: 'Grenada',
  [CountryCodes.GT]: 'Guatemala',
  [CountryCodes.HU]: 'Hungary',
  [CountryCodes.HN]: 'Honduras',
  [CountryCodes.IS]: 'Iceland',
  [CountryCodes.IL]: 'Israel',
  [CountryCodes.IE]: 'Ireland',
  [CountryCodes.IM]: 'Isle of Man',
  [CountryCodes.IT]: 'Italy',
  [CountryCodes.JM]: 'Jamaica',
  [CountryCodes.JP]: 'Japan',
  [CountryCodes.LV]: 'Latvia',
  [CountryCodes.LT]: 'Lithuania',
  [CountryCodes.ME]: 'Montenegro',
  [CountryCodes.NO]: 'Norway',
  [CountryCodes.PL]: 'Poland',
  [CountryCodes.PT]: 'Portugal',
  [CountryCodes.PR]: 'Puerto Rico',
  [CountryCodes.RO]: 'Romania',
  [CountryCodes.RU]: 'Russian Federation',
  [CountryCodes.KN]: 'Saint Kitts and Nevis',
  [CountryCodes.LC]: 'Saint Lucia',
  [CountryCodes.VC]: 'Saint Vincent and the Grenadines',
  [CountryCodes.SM]: 'San Marino',
  [CountryCodes.RS]: 'Serbia',
  [CountryCodes.SK]: 'Slovakia',
  [CountryCodes.SI]: 'Slovenia',
  [CountryCodes.ES]: 'Spain',
  [CountryCodes.SE]: 'Sweden',
  [CountryCodes.CH]: 'Switzerland',
  [CountryCodes.TR]: 'Turkey',
  [CountryCodes.UA]: 'Ukraine',
  [CountryCodes.GB]: 'United Kingdom of Great Britain and Northern Ireland',
  [CountryCodes.US]: 'United States of America',
  [CountryCodes.UY]: 'Uruguay',
  [CountryCodes.VU]: 'Vanuatu',
  [CountryCodes.VE]: 'Venezuela',
} as const

export const allCountries = AllCountries.getCountries()

// Filter out countries where residents are unlikely to be our customers
export const filteredCountries = allCountries.reduce<Record<string, Country>>(
  (previous, country) => {
    const id = country.iso2
    const name =
      allowedCountries[id?.toUpperCase() as keyof typeof allowedCountries]
    const dialCode = country.dialCode

    if (name && id && dialCode) {
      const record = {
        id,
        name,
        dialCode,
      }

      previous[id] = record
    }

    return previous
  },
  {},
)

export const DEFAULT_COUNTRY = 'US' as const

export const GENERIC_MASK = '+### ### ### ####'
